/**
 * BlogSLAlmadarBlogPage
 *
 * Page component for BlogSLAlmadarBlogPage
 * Path: /sl/blog
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { BlogSLBlogPageView as __BlogSLBlogPageView } from '@/components/traits/BlogSLBlogPageView';
import { BlogSLBlogAnalyticsView as __BlogSLBlogAnalyticsView } from '@/components/traits/BlogSLBlogAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface BlogSLAlmadarBlogPageProps {
  // Add any page-level props here
}

export function BlogSLAlmadarBlogPage(_props: BlogSLAlmadarBlogPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-blog:meta.title"],"description":["i18n/t","std-almadar-blog:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/blog"},{"locale":"ar","path":"/ar/blog"},{"locale":"sl","path":"/sl/blog"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__BlogSLBlogPageView config={{ initPayload: __navState }} />
          <__BlogSLBlogAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default BlogSLAlmadarBlogPage;
